import React, { useContext, useEffect, useState } from 'react';
import './Facilities.sass';
import '../MasterDataContainer.sass';
import IconButton from '../../../components/_controls/IconButton/IconButton';
import { MiscContext } from '../../../context/misc.context';
import Enums from '../../../enums';
import EditableTable from '../../../components/_tables/EditableTable/EditableTable';
import * as Presenter from './Facilities.presenter';
import { useHistory, useLocation } from 'react-router';
import GlobalHttpErrorHandler from '../../../errors/globalHttpErrorHandler';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import MasterDataService from '../../../services/masterData.service';

const Facilities = () => {

    // <> Context
    const { setMasterDataOpenedPopup, setMasterDataOpenedPopupState, addAlert, setOpenPopup, setOpenPopupState } = useContext(MiscContext);

    // <> History
    const history = useHistory();

    // <> States
    const [isLoading, setIsLoading] = useState(false);
    const [facilities, setFacilities] = useState([]);
    const [selectedFacility, setSelectedFacilities] = useState(null);

    // <> Effects
    useEffect(() => {
        getData();
    }, []);

    // <> Actions
    function onAddClicked() {
        setMasterDataOpenedPopup(Enums.AddMasterDataPopupTags.Facility);
        setMasterDataOpenedPopupState({ onSuccessFn: getData });
    }

    async function getData() {

        try {

            // -> Turn Loader ON
            setIsLoading(true);

            // -> Get Facilities From API
            const facilitiesResponse = await MasterDataService.getTables([
                Enums.MasterData.Facility
            ]);
            const facilitiesRes = facilitiesResponse.data.data[Enums.MasterData.Facility];
    
            // -> Format the data
            const facilitiesPresentable = Presenter.presentFacilities(facilitiesRes);
    
            // -> Set Data
            setFacilities(facilitiesPresentable);
            
        }
        catch(e) {
            GlobalHttpErrorHandler(e, history, addAlert);
        }
        finally {
            setIsLoading(false);
        }
    }

    async function updateField(rowId, fieldName, newValue) {
        console.log(`updated ${fieldName} of ${Enums.MasterData.Facility} #${rowId} to ${newValue}`);

        try {

            // -> Turn Loader ON
            setIsLoading(true);

            // -> Update Col in API
            await MasterDataService.updateCol(Enums.MasterData.Facility, rowId, fieldName, newValue);

            // -> Refetch Data
            getData();

        }
        catch(e) {
            GlobalHttpErrorHandler(e, history, addAlert);
            setIsLoading(false);
        }
    }

    async function deleteRow(rowId) {

        // -> Confirm
        setOpenPopupState({
            level: 'danger',
            message: 'Are you sure you want to delete this facility?',
            onOk: async () => {
                
                try {
        
                    // -> Turn Loader ON
                    setIsLoading(true);
        
                    // -> Update Col in API
                    await MasterDataService.deleteRow(Enums.MasterData.Facility, rowId);
        
                    // -> Refetch Data
                    getData();
                }
                catch(e) {
                    GlobalHttpErrorHandler(e, history, addAlert);
                    setIsLoading(false);
                }
                
            }
        })
        setOpenPopup(Enums.PopupTags.Confirmation);
        
    }

    // <> JSX
    return (
        <div className="master-data">

            <div className="master-data__top">
                
                {/* Patient Name */}
                <div className="master-data__top__title">Facilities</div>

                <div className="master-data__top__actions">
                    {/* Add Facility Button */}
                    <div className="master-data__top__actions__action">
                        <IconButton 
                            text={'Add'}
                            icon={faPlus}
                            onClickFn={onAddClicked} />
                    </div>
                </div>
            </div>

            <div className="master-data__container">

                <EditableTable
                    isLoading={isLoading}
                    items={facilities}
                    updateField={updateField}
                    deleteRow={deleteRow}
                    columnDefinitions={Presenter.tableColumnDefinitions()} />

            </div>

        </div>
    );
};

export default Facilities;